export default "__VITE_ASSET__Bf67GIgE__"